import { render, staticRenderFns } from "./ArchieveTab.vue?vue&type=template&id=416962f1&scoped=true"
import script from "./ArchieveTab.vue?vue&type=script&lang=js"
export * from "./ArchieveTab.vue?vue&type=script&lang=js"
import style0 from "./ArchieveTab.vue?vue&type=style&index=0&id=416962f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416962f1",
  null
  
)

export default component.exports